module.exports = __webpack_public_path__ + "img/discovercard.9f12febe.svg";